import React, { createContext, FC, useMemo, useState } from 'react';
import { Box, IconButton, Toolbar, Typography } from '@material-ui/core';
import AddBoxIcon from '@material-ui/icons/AddBox';
import CustomDialog from '../../common/components/CustomDialog';
import CompaignForm from '../../components/CompaignForm';
import useStyles from './styles';

export interface ICompaignFilter {
  filter: any;
}

export const CompaignFilterContext = createContext<ICompaignFilter>({
  filter: undefined,
});

const CompaignFilterProvider: FC = ({ children }) => {
  const classes = useStyles();

  const [filter, setFilter] = useState<any>(undefined);
  const [createFormOpened, setCreateFormOpened] = useState<boolean>(false);

  const value = useMemo(
    () => ({
      filter,
    }),
    [filter],
  );

  return (
    <CompaignFilterContext.Provider value={value}>
      <Toolbar className={classes.toolBar}>
        <Typography variant="h6">Liste des campagnes</Typography>
        <Box display="flex" flexDirection="row">
          <IconButton
            aria-label="delete"
            onClick={() => setCreateFormOpened(true)}>
            <AddBoxIcon />
          </IconButton>
        </Box>
      </Toolbar>

      {children}

      <CustomDialog
        fullWidth
        open={createFormOpened}
        title="Création campagne"
        onClose={() => setCreateFormOpened(false)}>
        <CompaignForm
          onCancel={() => setCreateFormOpened(false)}
          onCreate={() => setCreateFormOpened(false)}
        />
      </CustomDialog>
    </CompaignFilterContext.Provider>
  );
};

export default CompaignFilterProvider;
